module.exports = "\n/**\n * We're almost done.\n */\n\n pre:hover{\n   box-shadow: 0px 0px 40px 5px rgba(255,255,255,0.4);\n }\n\n #skip-animation, #pause-resume {\n   display: none;\n }\n\n/**\n * By the way, you can edit this box. Try adding new CSS!\n *\n * For example:\n *\n * The property 'text-shadow' takes the parameters:\n * 'x', 'y', 'blur', 'color'.\n */\n\n.value {\n  text-shadow: 0px 1px 10px white;\n}\n\n/**\n * Try it out! Make the page cooler... or break it ;)\n */\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./styles3.css
// module id = 89
// module chunks = 0 1